import { OrderState } from '@backend/domain'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ArrayMinSize, IsArray, IsOptional, IsUUID } from 'class-validator'
import { OrderItemResponse } from './order-item.dto'

export class OrderResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	currencyCode: string

	@ApiProperty({ type: Number })
	outstandingAmount: number

	@ApiProperty({ type: Number })
	paidAmount: number

	@ApiProperty({ type: Number })
	baseAmount: number

	@ApiProperty({ type: Number })
	taxPercentage: number

	@ApiProperty({ type: Number })
	taxAmount: number

	@ApiProperty({ type: Number })
	totalAmount: number

	@ApiProperty({ enum: OrderState })
	state: OrderState

	@ApiProperty({ type: Date, format: 'date-time' })
	createdAt: Date

	@ApiProperty({ type: String, isArray: true, format: 'uuid' })
	tableIds: string[]

	@ApiPropertyOptional({ type: String, format: 'uuid' })
	reservationId?: string

	@ApiProperty({ type: OrderItemResponse, isArray: true })
	items: OrderItemResponse[]
}

export class CheckinRequest {
	/**
	 * @deprecated
	 */
	@ApiPropertyOptional({
		type: String,
		format: 'uuid',
		deprecated: true,
		description: 'Use tableIds instead',
	})
	@IsOptional()
	@IsUUID()
	tableId?: string

	@ApiPropertyOptional({
		type: String,
		format: 'uuid',
		isArray: true,
		minItems: 1,
	})
	@IsOptional()
	@IsArray()
	@ArrayMinSize(1)
	@IsUUID('all', { each: true })
	tableIds?: string[]

	@ApiPropertyOptional({ type: String, format: 'uuid' })
	@IsOptional()
	@IsUUID()
	reservationId?: string
}

export class FreeTableCountResponse {
	@ApiProperty({ type: Number })
	count: number
}
